import { Box, Divider, Grid, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import { type FormikContextType, useFormikContext } from 'formik'
import React from 'react'
import type { AssetHolderUpdateDto } from '../../../api-schema-types/asset-holdings/AssetHolderCrudDtos'
import { useGetCurrentSettlementQuery } from '../../../api-services/asset-holdings/assetHolderApi'
import { RtkQueryHelper } from '../../../api-services/shared/RtkQueryHelper'
import ErrorComponent from '../../components/ui-widgets/ErrorComponent'
import FormikTextField from '../../components/ui-widgets/FormikTextField'
import LoadingComponent from '../../components/ui-widgets/LoadingComponent'
import type { EditAssetHolderProps } from './EditAssetHolderForm'

const ViewPortfolioSettlements: React.FC<EditAssetHolderProps> = ({ assetHolder }: EditAssetHolderProps) => {
  const formikProps: FormikContextType<AssetHolderUpdateDto> = useFormikContext()

  const getSettlementApiResult = useGetCurrentSettlementQuery({ assetHolderId: assetHolder.assetHolderId })

  const isLocked = (): boolean => {
    return true
  }

  return (
    <>
      <Box sx={{ pb: 4 }}>
        <Grid container spacing={1}>

          {/* ==================================================================================================== */}

          <Grid item md={12}>
            <h3>Login status</h3>
          </Grid>

          <Grid item md={1}>
            <Switch checked={assetHolder.assetHolderStatus.loginEnabled} disabled={true}/>
          </Grid>

          <Grid item md={5}>
            <FormikTextField formikProps={formikProps} fieldName={'assetHolderStatus.statusReason'} label={'Status'}
                             type={'text'} locked={isLocked()}/>
          </Grid>

          <Grid item md={6}>
            <FormikTextField formikProps={formikProps} fieldName={'assetHolderStatus.notes'} label={'Notes'}
                             type={'text'} locked={isLocked()}/>
          </Grid>
        </Grid>

        {/* ==================================================================================================== */}

        <Grid container spacing={1}>
          <Grid item md={12}>
            <h3>Account status</h3>
          </Grid>

          <Grid item md={1}>
            <Switch checked={assetHolder.assetHolderStatus.accountClosed} disabled={true}/>
          </Grid>

          <Grid item md={7}>
            <FormikTextField formikProps={formikProps} fieldName={'assetHolderStatus.closeReason'} label={'Close Reason'}
                             type={'text'} locked={isLocked()}/>
          </Grid>

          <Grid item md={4}>
            <FormikTextField formikProps={formikProps} fieldName={'assetHolderStatus.closedAtFormatted'} label={'Closed At'}
                             type={'text'} locked={isLocked()}/>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4 }}/>

        {/* ==================================================================================================== */}

        {getSettlementApiResult.isLoading && <LoadingComponent/>}
        {getSettlementApiResult.isError &&
          <ErrorComponent message={RtkQueryHelper.mapResponseError(getSettlementApiResult.error)}/>}

        {getSettlementApiResult.isSuccess && (
          getSettlementApiResult.data.map((settlement) => (

            <Box sx={{ mb: 4 }} key={settlement.assetHolderSettlementId}>
              <Box sx={{ display: 'flex' }} justifyContent={'space-between'}>
                <Typography variant={'h6'}>{settlement.settlementName}  / {settlement.state} / ID: {settlement.assetHolderSettlementId} </Typography>
                {settlement.accepted && (
                  <Box>
                    <Typography variant={'body1'} fontWeight={'bold'} component={'span'}>Accepted: </Typography>
                    <Typography variant={'body1'} component={'span'}>{settlement.acceptedByEmail} / {settlement.acceptedAtFormatted}</Typography>
                  </Box>
                )}
                {settlement.rejected && (
                  <Box>
                    <Typography variant={'body1'} fontWeight={'bold'} component={'span'}>Rejected: </Typography>
                    <Typography variant={'body1'} component={'span'}>{settlement.rejectedByEmail} / {settlement.rejectedAtFormatted}</Typography>
                  </Box>
                )}
              </Box>

              <TableContainer>
                <Table size="small" aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Project</TableCell>
                      <TableCell align="center">Total solar cells</TableCell>
                      <TableCell align="right">Cost of solar cells ({settlement.currencyCode})</TableCell>
                      <TableCell align="right">Total earnings ({settlement.currencyCode})</TableCell>
                      {/* <TableCell align="center">Settlement category</TableCell> */}
                      <TableCell align="right" width={'15%'}>Settlement Amount</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {settlement.projectSettlements.map((row) => (
                      <TableRow
                        key={row.projectId}
                        // sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell>{row.projectName}</TableCell>
                        <TableCell align="center">{row.countCells}</TableCell>
                        <TableCell align="right">{row.totalCostAmountFormatted}</TableCell>
                        <TableCell align="right">{row.totalEarningsAmountFormatted}</TableCell>
                        {/* <TableCell align="center">{row.settlementCategoryDescription}</TableCell> */}
                        <TableCell align="right">{row.settlementAmountFormatted}</TableCell>
                      </TableRow>
                    ))}

                    <TableRow>
                      <TableCell colSpan={6} align="right">{settlement.settlementTotalAmountFormatted}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

          )))}
      </Box>
    </>
  )
}

export default ViewPortfolioSettlements
